// common/services/player/listPlayerFamily.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export type PlayerFamilyRelationshipGroup =
  | 'parents_guardians'
  | 'additional_contacts'

export type PlayerFamilyRelationshipType = {
  id: number
  name: string
}

export type PlayerFamilyMember = {
  id: string
  name_first?: string | null
  name_last?: string | null
  full_name?: string | null
  /** Relationship of this contact to the player (BE RelationshipType object). */
  relationship_type?: PlayerFamilyRelationshipType | null
  email?: string | null
  phone_number?: string | null
  /** Whether the contact has administrative access to the player. */
  is_primary?: boolean | null
  /** Invitation status string (e.g. 'accepted', 'pending'). */
  status?: string | null
  /** True once the invited contact has accepted (drives the status dot color). */
  is_accepted?: boolean | null
} & Record<string, unknown>

export type PlayerFamilyPlayer = {
  id: string
  /** Display name shown in the invite sheet. */
  name_full?: string | null
  /** Image used in the invite sheet avatar. Backend returns the same shape
   *  as other player endpoints (`{ full_path, ... }`). */
  image?: { full_path?: string | null } | null
} & Record<string, unknown>

/**
 * GET /players/:playerId/family — returns the player's family contacts as a
 * flat array (each item is a full person with a `relationship_type` describing
 * their relationship to the player). There is no wrapping object or separate
 * `player` field. Consumed by the Family Management surface on web + mobile.
 *
 * Returns the raw member array; consumers map + group at their call site.
 */
export const listPlayerFamily = async (
  playerId: string
): Promise<PlayerFamilyMember[]> => {
  const { data } = await req(ENDPOINTS.PLAYERS.GET_PLAYER_FAMILY(playerId))
  return Array.isArray(data) ? (data as PlayerFamilyMember[]) : []
}
